import axios from 'axios';
import { authEvents } from './authEvents';
import { clearSessionActivity, recordActivity } from './sessionManager';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://infrasolapi.localhost.com';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    const url = response.config.url ?? '';
    if (
      !url.includes('/api/auth/login') &&
      !url.includes('/api/auth/refresh')
    ) {
      recordActivity();
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      clearSessionActivity();
      authEvents.emitUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default api;

